module.exports = __webpack_public_path__ + "assets/empty.799773e0.svg";